module.exports = __webpack_public_path__ + "img/splash_background.f3468a26.svg";